/**
 * Randomizes which products appear in the homepage "Featured collection"
 * product-list section (id ending in __product_list_X8Q7bi) on every page
 * load, so the section shows a different subset each time it's visited.
 *
 * The section is configured to render a larger pool of products (up to 16)
 * than are actually shown (6); this script picks a random subset of that
 * pool and hides the rest, and shuffles the display order.
 */
(function () {
  var VISIBLE_COUNT = 6;

  function shuffle(array) {
    var copy = array.slice();
    for (var i = copy.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = copy[i];
      copy[i] = copy[j];
      copy[j] = tmp;
    }
    return copy;
  }

  function init() {
    var wrapper = document.querySelector('[id$="__product_list_X8Q7bi"]');
    if (!wrapper) return;

    var items = Array.prototype.slice.call(wrapper.querySelectorAll('.resource-list__item'));
    if (items.length <= VISIBLE_COUNT) return;

    var container = items[0].parentElement;
    var shuffled = shuffle(items);
    var chosen = shuffled.slice(0, VISIBLE_COUNT);
    var chosenSet = new Set(chosen);

    items.forEach(function (item) {
      if (!chosenSet.has(item)) {
        item.style.display = 'none';
      }
    });

    chosen.forEach(function (item) {
      container.appendChild(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
